/* unplugin-vue-components disabled */import script from "./teacherName.vue?vue&type=script&lang=ts&setup=true"
export * from "./teacherName.vue?vue&type=script&lang=ts&setup=true"

export default script